import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    state: null,
    newState: null,
    project_id: null,
    name: "",
    standard: null,
    editedName: "",
    buildings: [],
    equipments: [],
    generatingPdf: false,
    maintenance: false,
    flagSubscription: null,
    imageOptimizationEnabled: false,
    users: null,
    stateSubscription: null,
    revokeAccessSubscription: null,
    available_standards: [],
    missingEquipmentUsers: [],
    date_shared: null,
  },
  mutations,
  actions,
};
